import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { HTTPService } from 'src/app/services/http.service';
import { Observable } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { FormulaTesterComponent, Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { DialogService } from 'src/app/services/dialog.service';
import { FormBuilder } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {map, startWith} from 'rxjs/operators';


export interface DialogData {
  entity: any;
  idInstance: any,
  instanceName:any,
  dpara: any;

  
}

export interface JsonField {
  name: string;
  column: string;
}

@Component({
    selector: 'app-dparamodal',
    templateUrl: './dparamodal.component.html',
    styleUrls: ['./dparamodal.component.scss'],
    standalone: false
})
export class DPARAModalComponent implements OnInit {
  displayedColumns: string[] = ['desc', 'field', 'type', 'key',  'dpara', 'df'];  

  formGroupJson: FormGroup;
  dataSource: any;
  columns: any[] = [];
  dates:Object = null;
  variables:Variable[] = [];
  loading = true;
  formula:string;
  isJSON: boolean = false;
  hasHeader: boolean = true;
  hasUpdate: boolean = false;
  multiCompany: boolean = false;
  token:string;
  url:string;
  headerLineNumber: any = 0;
  formHeader: UntypedFormGroup;
  //formHeader: FormGroup;
  jsonFields: JsonField[] = [];
  customJson:any;
  tokenHeight: number = 25;
  customJsonFields: any[];
  parameterType;
  filteredColumns: any[] = [];
  columnSearchControl = new FormControl();
  dparaValue:any;
  filteredFields: any[] = []; 
  searchField: string = '';
  showLoading:boolean = true;
  filteredOptions: Observable<string[]>;
  myControl = new FormControl('');
  originalColumns: any[] = [];
  filteredColumnsMap: { [key: string]: any[] } = {};



  
  constructor(
    public dialogRef: NzModalRef<DPARAModalComponent>,
    @Inject(NZ_MODAL_DATA) public data: DialogData, private http:HTTPService, private cdr:ChangeDetectorRef, private dialogServices:DialogService, private fb: FormBuilder) {      
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onColumnSelect(event): void {
    const filterValue = event.value.toLowerCase();
    this.filteredColumns = this.columns.filter(column =>
      column.COLUMNNAME.toLowerCase().includes(filterValue)
    );
  }


  ngOnInit(): void { 
    
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );

   

    
    this.formGroupJson = this.fb.group({});
    this.formGroupJson.addControl("envavar",new FormControl({value:null,disabled:true})); 

    let obinfo = {
      "entityName":"Mktpdiccol",
      "sql":`SELECT COLUMNNAME, DATATYPE, COLUMNDESC, ISPK, COLSIZE FROM Mktpdiccol (nolock) WHERE IDINSTANCE=${this.data.idInstance} ORDER BY ISPK DESC,COLUMNNAME`
    }         

    
    this.hasHeader = true;
    this.headerLineNumber = 0;
    this.hasUpdate = false;
    this.isJSON = false;
    this.multiCompany = false;
    this.url = "";
    this.token = "";
    this.showLoading = true;
    
    
    
    this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
      let info =  conInfo['SQL'];
      this.columns = info.map(column => ({ ...column, dparaValue: '', formula: ''}));
      
      this.originalColumns = [...this.columns];


      this.loading = false;
      this.cdr.detectChanges(); 
    });
      
  }

  _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
  
    return this.originalColumns.filter(option => option['COLUMNNAME'].toLowerCase().includes(filterValue));
  }

  resetFilter(): void {
    this.filteredColumns = [...this.originalColumns];
  }

  filterFields(): void {
    this.showLoading = true;

    this.filteredFields = this.customJsonFields.filter((field) =>
      field.key.toLowerCase().includes(this.searchField.toLowerCase())
    );

    this.showLoading = false;

  }

  getFieldControl(field: any): AbstractControl {
    return this.formGroupJson.get(`customJsonFieldsGroup.${this.customJsonFields.indexOf(field)}.dparaValue`);
  }

   updateFieldMapping(field: any, event:any): void {    
    field.dparaValue = event.option.value;    
    this.resetFilter();
  }
  
  parseCustomJson() {
    try {
      const parsedJson = JSON.parse(this.customJson);
  
      
      this.customJsonFields = [];
  
     
      this.processJsonFields(parsedJson, '');
      this.filterFields();

      this.filteredColumnsMap = {};
      
      for (const field of this.customJsonFields) {
        this.filteredColumnsMap[field.key] = [...this.columns];
      }
  
      
    } catch (error) {
      
      console.error('Erro ao analisar o JSON personalizado:', error);
    }
  }
  

  processJsonFields(jsonObj: any, prefix: string) {
    this.showLoading = true;
  
    for (const key in jsonObj) {
      if (jsonObj.hasOwnProperty(key)) {
        const value = jsonObj[key];
  
        if (Array.isArray(value)) {
          
          if (value.length > 0 && typeof value[0] === 'object') {
            
            value.forEach((obj, index) => {
              const fieldPrefix = `${prefix}${key}[${index}].`;
                
              this.processJsonFields(obj, fieldPrefix);
            });
          } else {
            const field = {
              key: prefix + key,
              value: value,
              columnName: '', // Coluna correspondente do banco de dados
              dataType: '', // Tipo de dado da coluna no banco de dados
              dparaValue: '', // Valor D-PARA
              formula: '' // Fórmula
            };
  
            const matchingColumn = this.columns.find(column => column.column === key);
            if (matchingColumn) {
              field.columnName = matchingColumn.columnName;
              field.dataType = matchingColumn.dataType;
            }
  
            this.customJsonFields.push(field);
          }
        } else if (typeof value === 'object') {
          this.processJsonFields(value, prefix + key + '.');
        } else {
          const field = {
            key: prefix + key,
            value: value,
            columnName: '', // Coluna correspondente do banco de dados
            dataType: '', // Tipo de dado da coluna no banco de dados
            dparaValue: '', // Valor D-PARA
            formula: '' // Fórmula
          };
  
          // Preencher columnName e dataType com base em this.columns
          const matchingColumn = this.columns.find(column => column.column === key);
          if (matchingColumn) {
            field.columnName = matchingColumn.columnName;
            field.dataType = matchingColumn.dataType;
          }
  
          this.customJsonFields.push(field);
        }
      }
    }
  
    this.showLoading = false;
  }
  

  generatePrefix(index: number): string {
    const prefix = 'field_';
    return prefix + index.toString();
  }

  loadJsonFromEndpoint(): void {
   
    /*this.http.get(this.url, this.token).subscribe((json) => {
      this.customJson = JSON.stringify(json);
    });*/
  }

  

  openEditFormula(column){
    this.variables = [];    

    this.dialogServices.openGenericDialog(FormulaTesterComponent,{formula:this.formula, variables:this.variables},(f)=>{
        if ( f['formula']){
          column.formula = f['formula'];
        }
        
    },()=>{},'80vh','80vw',false,null,'S','80px');
  }

    // Método para lidar com o evento de arrastar e soltar dos campos JSON
    dropJsonField(event: CdkDragDrop<any[]>) {
      moveItemInArray(this.customJsonFields, event.previousIndex, event.currentIndex);
    }
  
    // Método para lidar com o evento de arrastar e soltar das colunas do banco de dados
    dropColumn(event: CdkDragDrop<any[]>) {
      moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    }

    onDatabaseColumnDrop(event: CdkDragDrop<string[]>): void {
      moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    }

    onJsonFieldDrop(event: CdkDragDrop<string[]>): void {
      moveItemInArray(this.customJsonFields, event.previousIndex, event.currentIndex);
    }

}
